import { Injectable } from '@angular/core';
import { SimpleConfigBaseFilter } from 'gung-list';
import { Product } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class ProductGondolaBrandFilterService extends SimpleConfigBaseFilter<Product> {
  getName(): string {
    return 'GONDOLA_BRAND';
  }
  getOptionIds(item: Product): string[] {
    return [item.extra.hlPimItem.Gondola];
  }
  getOptionName(key: string): string {
    return key;
  }
}
